<template>
    <date-picker
        required="required"
        value-type="MM/DD/YYYY"
        id="return_date"
        type="date"
        autocomplete="asdf"
        :lang="lang"
        :default-value="default_return_date"
        :disabled-date="disabledReturnDays"
        @change="focusNextButton"
        v-model="return_date"
        inline
        format="MM-DD-YYYY">
    </date-picker>
</template>
<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker-latest'

export default {
    name: 'ReturnDatePicker',
    components: {DatePicker},
    mounted() {
        const thElements = document.querySelectorAll('.mx-calendar thead tr th');

        //calendar weeks replace "Mo => M, "SU => S"
        thElements.forEach((th) => {
            const text = th.textContent;
            th.textContent = text.charAt(0);
        });
    },
    data(){
        return {
            lang: {
                monthFormat: 'MMMM',
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            },
        };
    },
    computed:{
        default_return_date(){
            let min_booking_days = parseInt(this.min_booking_days);
            return moment(this.form.first_day_skiing).add(min_booking_days, 'days').format('MM/DD/YYYY');
        },
        return_date: {
            get () {
                return this.$store.state.form.return_date;
            },
            set (value) {
                value = moment(value).format('MM/DD/YYYY')
                this.$store.commit('SET_RETURN_DATE', value)
                // this.$store.state.packages = []; //needs to reset if rental length get changed it effects on prices.
                this.$store.state.cart.packages = []; //needs to reset if rental length get changed it effects on prices.
            },
        },
        ...mapState(['form', 'min_booking_days', 'season_start_at', 'season_end_at']),
    },
    methods: {
        disabledReturnDays(value) {
            let min_booking_days = parseInt(this.min_booking_days);
            let first_day_skiing = this.form.first_day_skiing ? new Date(this.form.first_day_skiing) : new Date(this.season_start_at);
            first_day_skiing.setDate(first_day_skiing.getDate() + min_booking_days);
            let date = new Date(value);
            if (moment(date).isBefore(first_day_skiing)) {
                return true;
            }
        },
        focusNextButton(){
            let buttonEle = document.getElementById('return-select');
            if(buttonEle){
                this.cursorFocus(buttonEle,'nearest')
            }
        },
        cursorFocus(elem, block='nearest') {
            setTimeout(() => {
                const dropdownMenu = elem.closest('.bs3-drp-menu');
                if (dropdownMenu) {
                    dropdownMenu.scrollTop = dropdownMenu.scrollHeight;
                }
                elem.focus();
                elem.scrollIntoView({behavior: "smooth", block: block});
            }, 100);
        },
    }
}
</script>
